import { Typography } from '@mui/material';
import { Props } from 'src/features/@types/cardImageIcon';
import {
  StyledButton,
  StyledButtonContainer,
  StyledContainer,
  StyledImage,
  StyledTextContainer,
} from './styles';

// ---------------------------------------------------------------------------------------------

export default function CardImageAction({ title, children, path, titleButton, url }: Props) {
  return (
    <StyledContainer>
      <StyledImage src={url} alt="imagem de desenho de projeto a mão" />

      <StyledTextContainer>
        <Typography variant="h4" mb={2}>
          {title}
        </Typography>

        <Typography variant="inherit" sx={{ color: 'text.secondary' }} width="100%">
          {children}
        </Typography>

        <StyledButtonContainer>
          <a
            href={path}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <StyledButton variant="contained" color="primary">
              {titleButton}
            </StyledButton>
          </a>
        </StyledButtonContainer>
      </StyledTextContainer>
    </StyledContainer>
  );
}
